var map = {
	"./10-2.png": "68e9",
	"./11-2.png": "84c9",
	"./12-2.png": "e524",
	"./7-2.png": "e4f4",
	"./8-2.png": "e522",
	"./9-2.png": "c35d",
	"./piece/1-2.png": "cbab",
	"./piece/2-2.png": "f50f",
	"./piece/3-2.png": "96ab",
	"./piece/4-2.png": "072c",
	"./piece/5-2.png": "6858",
	"./piece/6-2.png": "2911"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "233d";